<template>
    <v-btn-toggle borderless active-class="white elevation-4" color="primary" class="grey lighten-4" style="width:100%;border-radius:8px!important">
        <template v-for="{ text, to, className } in tabs">
            <v-btn
                exact
                width="calc(100% / 3)"
                style="border-radius: 8px!important;"
                v-bind="{
                    to,
                    class: className,
                }"
                :key="text"
                @click.capture.stop.prevent="emit(to)"
            >
                {{ text }}
            </v-btn>
        </template>
    </v-btn-toggle>
</template>

<script>
export default {
    computed: {
        tabs() {
            return [
                {
                    text: "ebook",
                    to: {
                        query: { ...this.$route.query, code: "ebook" },
                    },
                },
                {
                    text: "도서",
                    to: {
                        query: { ...this.$route.query, code: "book" },
                    },
                },
                {
                    text: "도서 선물내역",
                    to: {
                        query: { ...this.$route.query, code: "gift" },
                    },
                },
            ].map((item) => ({
                ...item,
                className: this.$route.query.code == item.to.query.code ? undefined : "transparent",
            }));
        },
    },
    methods: {
        emit(to) {
            to = JSON.parse(JSON.stringify(to));
            to.query = { code: to.query.code };
            this.$router.push(to);
        },
    },
};
</script>

<style lang="scss" scoped>
.v-btn-toggle > .v-btn.v-btn--active {
    opacity: 1;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn--active.white {
    border-width: 1px;
    border-style: solid;
    border-color: var(--v-primary-base) !important;
}
</style>
